export default "__VITE_PUBLIC_ASSET__52b76575__"